import { Icon, IconOffer } from '@flixbus/honeycomb-icons-react';
import { Button, Divider, Tooltip } from '@flixbus/honeycomb-react';

import PageList from './PageList';
import DisableButton from './DisableButton';
import EnableButton from './EnableButton';

import styles from './voucher-actions.module.scss';
import ChangeExpiration from './ChangeExpiration';
import DownloadVouchers from './DownloadVouchers';

const VoucherActions = () => {
  return (
    <div className={styles.container}>
      <Divider extraClasses={styles.divider} />
      <div className={styles.actions}>
        <Tooltip
          id='language-selection'
          size='large'
          position='bottom'
          alignment='start'
          content={<PageList />}
        >
          <Button Elem='a' appearance='primary'>
            <Icon InlineIcon={IconOffer} />
            New
          </Button>
        </Tooltip>
        <DownloadVouchers />
        <ChangeExpiration />
        <DisableButton />
        <EnableButton />
      </div>
    </div>
  );
};

export default VoucherActions;
